namespace TabAurous.Finance {
    export interface ReceiptRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        UserId?: number;
        EnteredBy?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        KnockOffTotal?: number;
        Details?: ReceiptDetailsRow[];
        PartyBalance?: PartyBalanceRow[];
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        Pincode?: string;
        GstVat?: string;
        Pan?: string;
        BankId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.Receipt';
        export const deletePermission = 'Finance:Receipt:Delete';
        export const insertPermission = 'Finance:Receipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Receipt:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            UserId = "UserId",
            EnteredBy = "EnteredBy",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            KnockOffTotal = "KnockOffTotal",
            Details = "Details",
            PartyBalance = "PartyBalance",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            Pincode = "Pincode",
            GstVat = "GstVat",
            Pan = "Pan",
            BankId = "BankId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
